export default "__VITE_ASSET__Dsyky7IE__"